/**
 * templateScope.js — IDI-213 quote-template save/apply scope.
 *
 * Ruling (2026-08-28): a quote template carries the WORK (areas/sub-areas, line
 * items, sqft, products/coverage, accessories+qty, additional labor/cost, and
 * line-item notes) but NOT the deal context: customer/contact, job address,
 * project name, job type, lead source, and — critically — MARGIN.
 *
 * Margin is resolved at APPLY time from the TARGET customer's cascade
 * (category → customer → customer-type → overall). A margin baked into the
 * template would override that resolution and silently misprice the new
 * customer's quote (the family-C hazard: a template built at 30% must not
 * force 30% onto a customer whose type resolves 42%).
 *
 * This module is the single home for the margin-strip so save and apply agree.
 */

// Per-line margin fields that must never travel with a template.
const MARGIN_FIELDS = ['lineMargin', 'margin_pct', 'margin_override', 'grossMargin', 'gross_margin'];

/**
 * Strip per-line margin from template line items so the applied quote
 * re-resolves margin from the target customer. Pure; returns new objects.
 *
 * @param {Array} lineItems
 * @returns {Array}
 */
export function stripTemplateMargin(lineItems) {
  if (!Array.isArray(lineItems)) return [];
  return lineItems.map((li) => {
    if (!li || typeof li !== 'object') return li;
    const clean = { ...li };
    for (const f of MARGIN_FIELDS) delete clean[f];
    return clean;
  });
}

export { MARGIN_FIELDS as TEMPLATE_MARGIN_FIELDS };
